import { ReturnProcess } from '@/domain/returns'
import { useSubmitAuthorization } from '@/hooks/use-submit-authorization'
import { useAppSelector } from '@/redux/hooks'
import { Button, Base, ReverLoading } from '@itsrever/design-system'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

const { Card } = Base

interface UnauthorizeIslandProps {
  processDetails: ReturnProcess | undefined
  setUnauthorizeMode: (value: boolean) => void
}

const UnauthorizeIsland: React.FC<UnauthorizeIslandProps> = ({
  processDetails,
  setUnauthorizeMode
}) => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { mutate: submitAuthorization, isPending: loadingAuthorization } =
    useSubmitAuthorization()
  const user = useAppSelector(
    (store) => store.userApi.getMe.response.user?.name
  )
  const customerPreferredLanguage =
    processDetails?.customer.preferredLanguage ?? ''
  const [reason, setReason] = useState('')
  const { i18n } = useTranslation()

  const unauthorizeProcess = () => {
    submitAuthorization({
      authorized: false,
      process_id: id,
      unauthorized_reason: reason,
      user: user
    })
  }
  const [showCancelTextValidation, setShowCancelTextValidation] =
    useState(false)

  useEffect(() => {
    if (reason.length >= 5) {
      setShowCancelTextValidation(false)
    }
  }, [reason])

  return (
    <>
      <Card className="h-fit p-5">
        {loadingAuthorization ? (
          <ReverLoading />
        ) : (
          <div>
            <h6 className="text-sm font-semibold">
              {t('process_details_page.unauthorize_reason')}
            </h6>
            <p className="mt-2">
              <p>
                {t('process_details_page.unauthorize_description_1')}
                <br />
                {t('process_details_page.unauthorize_description_2')}
              </p>
            </p>
            <div className="my-3">
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className="outline-3 w-full rounded-md border p-3 text-sm outline-gray-200 transition-all ease-in-out hover:outline"
                rows={3}
                placeholder="Example: The item is not defective, please start a new return with a different return reason."
              />
              {showCancelTextValidation && (
                <p className="text-xs text-red-600">
                  {t('cancel_processes.modal_reason_validation')}
                </p>
              )}
            </div>
            {customerPreferredLanguage ? (
              <div className="flex">
                <p className="mb-5 flex rounded-md bg-gray-200 px-2 py-1 text-sm text-gray-700">
                  {t('process_details_page.unauthorize_shopper_language')}:
                  <span className="ml-2 font-bold">
                    {new Intl.DisplayNames([i18n.language], {
                      type: 'language'
                    }).of(customerPreferredLanguage)}
                  </span>
                </p>
              </div>
            ) : null}
            <div>
              <div className="flex justify-center gap-4">
                <Button
                  onClick={() => {
                    if (reason.length < 5) {
                      setShowCancelTextValidation(true)
                      return
                    }
                    unauthorizeProcess()
                  }}
                >
                  {t('process_details_page.unauthorize_confirm')}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => setUnauthorizeMode(false)}
                >
                  {t('products_tab.cancel')}
                </Button>
              </div>
            </div>
          </div>
        )}
      </Card>
    </>
  )
}
export default UnauthorizeIsland
